import { FC } from "react";
import classNames from "classnames";
import { HeadingProps } from "./Heading.types";
import styles from "./Heading.module.scss";
import Base from "../Base";

const Heading: FC<HeadingProps> = ({
  size = 1,
  className,
  inherit = false,
  inheritColor = false,
  inheritFont = false,
  component,
  ...otherProps
}) => {
  const tag = `h${size}` as const;
  return (
    <Base
      component={component || tag}
      className={classNames(
        styles.heading,
        {
          [styles[tag]]: !inherit,
          [styles.inherit]: inherit,
          [styles["inherit-color"]]: inheritColor,
          [styles["inherit-font"]]: inheritFont,
        },
        className
      )}
      {...otherProps}
    />
  );
};

export default Heading;
